import { Component, EventEmitter, OnInit, Output, OnDestroy, ViewChild } from '@angular/core';
import { QueryService } from './query.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

import { ModalDirective } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

import { QueryStates } from './query.reducer';
import { ArgumentEntered, Section } from './argument/argument.model';
import * as actions from './query.actions';
import { ExportService } from 'src/app/_services/export.service';
import { log } from 'console';



@Component({
  selector: 'app-query',
  templateUrl: './query.component.html',
  styleUrls: ['./query.component.scss']
})
export class QueryComponent implements OnInit , OnDestroy {
  tabIndex = 0;
  viewType = 'list';
  showScenarios = true;
  showArgumentos = true;
  loading = false ;
  queryconfigtype = '';
  graphreport = false ;
  opctionsConfig = {};
  msgSpiner = 'Cargando...';
  configQuery = [];

  showTitlle = true; // titulo corresponde a la opcion del menu seleccionada
  //
  currenteNameQuery = ''; // label de la query actual seleccionada // la consulta corresponde al escenario seleccionado
  scenarios: any=[];
  sections: any=[];
  dataGrid: any;
  argToSend: any;
  optionmenu: string;
  queryid: string;
  basedonid: string;
  displayMacro: boolean;
  displayRpt:boolean;

  valGraficDispersionPetrofisica: boolean;

  form: FormGroup;
  submitted = false;
  reportlocation:string = null;
  paginationflag = ''; //bandera  de paginacion
  dataGrafic:any[]=[];

  @Output() onEventSetSplit = new EventEmitter<boolean>();

  listArguments: ArgumentEntered [] = [] ;

  subscriptionProcessStore: Subscription;

  listComponent: any[] = [];
  listUnit: any[]=[];

  constructor(  private activatedRoute: ActivatedRoute,
                private formBuilder: FormBuilder,
                private queryService: QueryService,
                private store: Store<QueryStates>,
                public spinner: NgxSpinnerService,
                private exportService: ExportService,
                private toastr: ToastrService) {
      this.subscriptionProcessStore = this.store.select('processQueryState').subscribe(stateProcess => {
        this.processStateManage(stateProcess);
    });
    }

   ngOnInit() {
      console.log("QueryId: ", this.queryid);

      this.optionmenu = this.activatedRoute.snapshot.params['optionmenu'];
      this.queryid = this.activatedRoute.snapshot.params['queryid'];
      this.basedonid = this.activatedRoute.snapshot.params['basedonid'];

      this.spinner.show();
      this.queryService.getScenarios(this.queryid, this.basedonid).subscribe( (responseScenario: any[]) => {
        // console.log("Respuesta escenarios: ", responseScenario);
        this.scenarios =  responseScenario;
       // console.log("responseScenario[0]: ", responseScenario[0]);
        this.queryconfigtype = responseScenario[0].queryconfigtype;

        this.reportlocation =  responseScenario[0].reportlocation;
        this.currenteNameQuery = responseScenario[0].name;
        this.graphreport = responseScenario[0].graphicreport;
        this.paginationflag = responseScenario[0].paginationflag;
        this.opctionsConfig = {
          exportpdfflag: responseScenario[0].exportpdfflag ,
          exportxlsflag : responseScenario[0].exportxlsflag
        };

        this.sections = responseScenario[0].sections;
        /// inicializar formulario
        // console.log('fIN CARga escenarios');
        this.onToFormGroup(this.sections);
        this.spinner.hide();
      }, err => {
        this.toastr.error('Error consulta de escenarios: ' +  err);
        this.spinner.hide();
        // console.log('Error consulta de escenarios:: ', err);
      });
    // ocultar escenarios
      this.showScenarios = !this.showScenarios;
  }

  ngOnDestroy() {
    this.subscriptionProcessStore.unsubscribe();
   }

  changeView(_view: string){
      this.viewType = _view
  }

  onEventShowScenarios(e){
    this.showScenarios = e; // e recibe el valor desde la barra de opciones para habilitarlo
  }

  onEventShowArgumentos(e){
    this.showArgumentos = e; // e recibe el valor desde la barra de opciones para habilitarlo
    setTimeout(() => {this.tabIndex=0;}, 1);  // sincronizar cambio de tabs

  }

  setSections(data: any) {    
     this.sections = data.sections;
     this.setIdArgs(); /// crear Id de argumento
     setTimeout(() => {this.tabIndex=0;}, 1);  // sincronizar cambio de tabs
     this.currenteNameQuery = data.name; /// nombre del escenario
     this.queryconfigtype = data.queryconfigtype;
     this.queryid = data.queryId;
     this.basedonid = data.basedonId;
     this.reportlocation = data.reportlocation;
     this.paginationflag = data.paginationflag;
     this.form = null; // reinicio formulario
     this.onToFormGroup(this.sections);
  }

  setIdArgs() {
    /*this.sections.forEach(items => {
      items.group.forEach(arg => {
        arg.argid = arg.queryArgumentId.argid;
      });
    });
*/
  }

  onToFormGroup(sections: Section[]) {
    // inicializar fomrulario con los argumentos de la seccion seleccionada
    this.form = this.queryService.onToFormGroup(sections);
  }

  async processStateManage(stateProcess){
    // console.log('estado proceso desde query' , stateProcess);
    this.msgSpiner = 'Cargando ...';
    switch (stateProcess.stateProcess) {
      case 'Initial':
          break;
      case 'Invalid':
            this.submitted = true;
            break;
      case 'Valid':
        this.msgSpiner = 'Consultado datos...';
        // / ocultar scenarios / ocultar argumentos
        this.showScenarios = this.showScenarios? false:false;
        this.showArgumentos = this.showArgumentos? false:false;
        // Cargar valores por defecto a argumentos

        await this.setDefaultValueArgsForms(this.sections);
        this.submitted = false;
        console.log('Valores a enviar' , this.listArguments );
        this.store.dispatch(actions.setProcessState({stateProcess: 'Execute' ,
         options: {
          args:this.listArguments,
          queryid:  this.queryid ,
          basedonid: this.basedonid
        }}));

        break;
      case 'Set Section':
        this.showArgumentos = true;
        this.showScenarios = false;
        break;
      case 'Export Special':
        this.msgSpiner = 'Exportando datos....';
        // console.log('Ejecutando Exportacion, Componente Query');
        this.exportMacro();
        break;
      case 'Export Grafico':
        /*if(this.queryid ==='ReportePetrofisica' || this.queryid ==='HistoricoReportePetrofisica'){
          console.log("Entro historico");
          // valGraficDispersionPetrofisica = true;
          this.listTipoGrafico = [{type: 'Dispersion', image: 'assets/images/Dispersion.png'}];
          this.valGraficDispersionPetrofisica = true;
          this.onOpenModalGraficoDispersion();
        }else{
          this.onOpenModalGrafico();
        }*/
        break;
      case 'Export Report':
        console.log("this.reportlocation:", this.reportlocation);
        this.store.dispatch(actions.setProcessState({stateProcess: 'Execute Reports Macro' ,
       options: {queryid:  this.queryid, args:this.listArguments, reportlocation: this.reportlocation}}));
        break;
      case 'Print Labels':
        this.printLabel();
        break;

    }
  }

  printLabel(){
    console.log(this.listArguments, 'los argumentos pa');
    
    this.spinner.show();
    let ncopias: any = "";
    let sample = this.listArguments.find(item => item.argid === '[arg2]' ).argdata ;
    let impresora = this.listArguments.find(item => item.argid === '[arg3]' ).argdata ;
    let metodo = this.listArguments.find(item=> item.argid === '[labelmethod]').argdata;
    if (this.listArguments.find((item) => item.argid === "[ncopias]")) {
      ncopias = this.listArguments.find((item) => item.argid === "[ncopias]").argdata
    }else{
      ncopias =1;
    }
    let objectUser = {
      "databaseid": sessionStorage.getItem('database'),
      "username": sessionStorage.getItem('username'),
      "password": sessionStorage.getItem('password')
    }
    let objectPrintLabel = {
      metodo: metodo,
      sample: sample,
      impresora: impresora,
      connectionId: null,
      ncopias: ncopias, 
    };

    this.queryService.onGetConnection(objectUser).subscribe((res: any) =>{
      objectPrintLabel.connectionId=res.connections.connectionid;
      this.queryService.onGetPrintLabel(objectPrintLabel).subscribe((res: any[]) =>{
        //console.log("Respuesta: ",res);
        this.toastr.success("Proceso Exitoso");
        this.spinner.hide();
      },err =>{
        this.toastr.error("Error al Imprimir Etiqueta");
       this.spinner.hide();
     });
    });
  }

  ongetUnit(){
     this.queryService.onGetDataGrafic(this.dataGrafic, 'UNITS').subscribe((res: any[]) =>{
      this.listUnit = res;
    },err =>{
    });
  }

  ongetComponent(){
    this.queryService.onGetDataGrafic(this.dataGrafic, 'COMPONENT').subscribe((res: any[]) =>{
     this.listComponent = res;
     this.spinner.hide();
   },err =>{
    this.spinner.hide();
  });
 }

  setDefaultValueArgsForms(sections) {
    console.log('seccion recibida', sections)
    return new Promise (resolve => {
      let _listArguments: ArgumentEntered [] = [] ;
      for (const section of sections){
       for (const items of section.args){
           for (const arg of items.group) {
             let ElementsTextArg = '';
            // console.log('argumnto a validar : ' + typeof (this.form.value[arg.argid])  , arg)
             if ((arg.argtype === 'dateonly' || arg.argtype === 'absreldt')  && this.form.value[arg.argid].length === 0 )  {
                this.form.value[arg.argid] = 'null';
              }
             if (typeof (this.form.value[arg.argid]) === 'object' && //
                (arg.argtype !== 'dateonly' && arg.argtype !== 'absreldt')) {
                  let arrElementsString = '';
                  let totalElements = 0;
                  if (this.form.value[arg.argid] == null) { this.form.value[arg.argid] = "" }
                  // console.log('Longitud campo: ' ,  this.form)
                  if (this.form.value[arg.argid].length) {
                    for (const element of this.form.value[arg.argid]){
                      if (totalElements > 0) {
                        arrElementsString = arrElementsString + `,`;
                      }
                      arrElementsString = arrElementsString + `'${element.value}'`;
                      totalElements += 1;
                    }
                  } else {
                    arrElementsString = this.form.value[arg.argid].value;
                    ElementsTextArg = this.form.value[arg.argid].text;
                  }
                  this.form.value[arg.argid] = arrElementsString;
              }
            //  if ((arg.argtype === 'dateonly' || arg.argtype === 'absreldt') && this.form.value[arg.argid].length > 0)  {
            //     this.form.value[arg.argid] = this.intlService.formatDate(this.form.value[arg.argid]);
            //   }
             let argument: ArgumentEntered = {
              argid : `[${arg.argid}]`,
              argdesc : arg.argdesc,
              argdata : (this.form.value[arg.argid]== null) ? "" : this.form.value[arg.argid] ,
              argtext : (this.form.value[arg.argid]== null) ? "" : (ElementsTextArg === '') ? this.form.value[arg.argid] : ElementsTextArg ,
              argtype : arg.argtype
              };
             _listArguments.push(argument);
           }
         }
      }
     console.log('Formulario' , this.form);
     // console.log('nuevo arreglo', listArguments);
     this.listArguments = _listArguments;
     console.log('Valores calculados' , this.listArguments );
     resolve(0);
    })

  }



  async onEventSubmitJasperPdf(){
    let listArgumentsExport: any[] = [];
    if( this.queryconfigtype ==='onlyjasper'){
      await this.setDefaultValueArgsForms (this.sections);
      let argFind = this.listArguments.find(item => item.argid === '[reporte]' ) ;
      if(argFind){
        this.reportlocation = argFind.argdata;
      }
      if(this.reportlocation !== 'null'){
        //REEMPLAZAR LA DECLARACION DE VARIABLES EXISTENTE POR ESTA
        this.exportOnlyJasper('pdf');
      }
    }else{
      this.spinner.show();
      let args: any [] =  Object.assign ([], this.listArguments);
      for (let arg of this.listArguments) {
        let argCopy: any=  Object.assign ({}, arg);
        if ((argCopy.argtype === 'dateonly' || argCopy.argtype === 'absreldt') && argCopy.argdata !== 'null') {
          if(argCopy.argdata instanceof Date){
            let date = null;
            let day = "";
            let month = "";
            if (new Date(argCopy.argdata).getDate() < 10) {
              day = '0' + new Date(arg.argdata).getDate();
            }
            date = new Date(argCopy.argdata);
            argCopy.argdata = `${day !== "" ? day : new Date(argCopy.argdata).getDate()}/${month !== "" ? month : new Date(argCopy.argdata).getMonth() + 1}/${new Date(argCopy.argdata).getFullYear()}`;
            argCopy.argtext = argCopy.argdata;
          }
        }
        listArgumentsExport.push(argCopy);
      }
      let objectReportTemplate = {
        "format": "pdf",
        "reportname": this.queryid,
        "queryId": this.queryid,
        "basedonId": this.basedonid,
        "encabezado": [],
        "level": 1,
        "arguments": listArgumentsExport
      }
      objectReportTemplate.arguments = this.objectLogoName(objectReportTemplate.arguments);
      objectReportTemplate.arguments = objectReportTemplate.arguments.map((item) => ({
        name: item.argid === undefined ? "" : item.argid,
        title: item.argdesc === undefined ? "" : item.argdesc,
        value: item.argdata === undefined ? "" : item.argdata,
        text: item.argtext === undefined ? "" : item.argtext,
      }));
      this.queryService.onGetJasperTemplate(objectReportTemplate).subscribe(res =>{
        this.exportService.executeReport(res, 'pdf', this.queryid);
        this.spinner.hide();
      }, err => {
        this.toastr.error("Error al exportar")
        this.spinner.hide();
      });
    }
  }
  async onEventSubmitJasperXls(){

    let listArgumentsExport: any[] = [];
    if(this.reportlocation !== 'null' && this.queryconfigtype ==='onlyjasper'){
      await this.setDefaultValueArgsForms (this.sections);
      //REEMPLAZAR LA DECLARACION DE VARIABLES EXISTENTE POR ESTA
      this.exportOnlyJasper('xlsx');
    }else{
      for (let arg of this.listArguments) {
        let argCopy: any=  Object.assign ({}, arg);
        if ((argCopy.argtype === 'dateonly' || argCopy.argtype === 'absreldt') && argCopy.argdata !== 'null') {
          if(argCopy.argdata instanceof Date){
            let date = null;
            let day = "";
            let month = "";
            if (new Date(argCopy.argdata).getDate() < 10) {
              day = '0' + new Date(arg.argdata).getDate();
            }
            date = new Date(argCopy.argdata);
            argCopy.argdata = `${day !== "" ? day : new Date(argCopy.argdata).getDate()}/${month !== "" ? month : new Date(argCopy.argdata).getMonth() + 1}/${new Date(argCopy.argdata).getFullYear()}`;
            argCopy.argtext = argCopy.argdata;
          }
        }
        listArgumentsExport.push(argCopy);
      }
      this.spinner.show();
      let objectReportTemplate = {
        "format": "xls",
        "reportname": this.queryid,
        "queryId": this.queryid,
        "basedonId": this.basedonid,
        "encabezado": [],
        "level": 1,
        "arguments": listArgumentsExport
      }
      objectReportTemplate.arguments = this.objectLogoName(objectReportTemplate.arguments);
      objectReportTemplate.arguments = objectReportTemplate.arguments.map((item) => ({
        name: item.argid === undefined ? "" : item.argid,
        title: item.argdesc === undefined ? "" : item.argdesc,
        value: item.argdata === undefined ? "" : item.argdata,
        text: item.argtext === undefined ? "" : item.argtext,
      }));
      this.queryService.onGetJasperTemplate(objectReportTemplate).subscribe(res =>{
        this.exportService.executeReport(res, 'xls', this.queryid);
        this.spinner.hide();
      }, err => {
        this.toastr.error("Error al exportar")
        this.spinner.hide();
      });
    }
}

objectLogoName(args){
  let logoName = {
    "argdata":sessionStorage.getItem('logonName'),
    "argtext": sessionStorage.getItem('logonName'),
    "argid": "[LOGON_NAME]",
    "argdesc": "Usuario",
    "argtype": "string"
  }
  let sysUserId = {
    "argdata":sessionStorage.getItem('sysUserId'),
    "argtext": sessionStorage.getItem('sysUserId'),
    "argid": "[SYSUSERID]",
    "argdesc": "sysUserId",
    "argtype": "string"
  }
  args.push(logoName);
  args.push(sysUserId);
  return args
}

async exportMacro() {
  this.spinner.show();
  let args =  null;
  // console.log("Argumntos Iniciales special: ", this.listArguments);

  await this.setDefaultValueArgsForms (this.sections);
  /// console.log("Argumntos Finales special: ", this.listArguments);
  args =  Object.assign ([], this.listArguments);
  this.queryService.onGetDataMacro(this.queryid, args)
  .subscribe (res =>{
    this.exportService.executeReport(res, 'xls', this.queryid);
    this.spinner.hide();
  });
}


exportOnlyJasper(format){
  console.log('Lista Argumentos Export OnlyJasper', this.listArguments )
  this.spinner.show();
  let map = new Map<string, string>();
  let jsonObject = {};
  this.listArguments.forEach(element => {
    let valorArg = Object.assign ({}, element);
    valorArg.argid = valorArg.argid.replace("[", "").replace("]", "");
    jsonObject[valorArg.argid] = this.formatArgumentDateString(valorArg).argdata;
  });
  this.queryService.onGetJasper(this.reportlocation, jsonObject, format, this.queryid).subscribe(res =>{
    this.exportService.executeReport(res, format, this.queryid);
    this.spinner.hide();
  }, err => {
    this.toastr.error("Error al exportar")
    this.spinner.hide();
  });
}

formatArgumentDateString( arg){
  if ((arg.argtype === 'dateonly' || arg.argtype === 'absreldt' || arg.argtype === 'date') && arg.argdata !== 'null') {
     // console.log("es fecha->" + arg.argdata, new Date(arg.argdata))
      let date = null;
      let day = "";
      let month = "";
      console.log("Mes: ", arg.argdesc, " :", new Date(arg.argdata).getMonth());
      if (new Date(arg.argdata).getDate() < 10) {
        day = '0' + new Date(arg.argdata).getDate();
      }
      if (new Date(arg.argdata).getMonth() +1 < 10) {
        month = '0' + (new Date(arg.argdata).getMonth() + 1);
      }
      date = new Date(arg.argdata);
      if(arg.argtype === 'absreldt'){
        arg.argdata = `${day !== "" ? day : new Date(arg.argdata).getDate()}/${month !== "" ? month : new Date(arg.argdata).getMonth() + 1}/${new Date(arg.argdata).getFullYear()} ${arg.argdata.getHours()}:${arg.argdata.getMinutes()}`;
        arg.argtext = arg.argdata;
      }else{
        arg.argdata = `${day !== "" ? day : new Date(arg.argdata).getDate()}/${month !== "" ? month : new Date(arg.argdata).getMonth() + 1}/${new Date(arg.argdata).getFullYear()}`;
        arg.argtext = arg.argdata;
      }
      arg.argtype === 'string';
  }
  return arg;
}


}
